var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { Icon } from '@material-ui/core';
import * as classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Message from 'src/components/reusable/Message';
var styles = function (theme) { return ({
    success: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
    },
}); };
// @ts-ignore
var PopupNotification = /** @class */ (function (_super) {
    __extends(PopupNotification, _super);
    function PopupNotification(props) {
        return _super.call(this, props) || this;
    }
    PopupNotification.prototype.render = function () {
        return (React.createElement("div", { className: "custom-notification" },
            React.createElement("div", { className: classNames(this.props.classes.success, 'custom-notification__icon') },
                React.createElement(Icon, null, "check")),
            React.createElement("div", { className: "custom-notification__text" },
                React.createElement("p", { className: "word-break" },
                    React.createElement(Message, { html: this.props.notification.title })))));
    };
    PopupNotification = __decorate([
        withStyles(styles, { withTheme: true })
    ], PopupNotification);
    return PopupNotification;
}(React.Component));
export { PopupNotification };
export default PopupNotification;



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/PopupNotification.tsx
// module id = 2054
// module chunks = 81